import PerformanceMeasurePlugin from './performance-measure';

export default {
  PerformanceMeasurePlugin,
};
